<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Evaluation/components/User/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>